import { NgModule } from '@angular/core';
import { CarouselGalleryComponent } from './carousel-gallery.component';
import { MaterialModule } from '../../material.module';
import { CommonModule } from '@angular/common';
import { ActionButtonModule } from '../action-button';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [CarouselGalleryComponent],
  imports: [MaterialModule, CommonModule, ActionButtonModule, SvgIconModule],
  exports: [CarouselGalleryComponent],
})
export class CarouselGalleryModule {}
